module.exports = __webpack_public_path__ + "media/images/sp/accessories/dress/dress_04_thumb-f9c432c7b577434fa92d7d1ad87154e1.jpg";